
export enum TextBadgeVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error'
}

export interface TextBadgeLayoutProps {
  text: string
  variant?: TextBadgeVariant
  isSmall?: boolean,
  title?: string,
}
